const fixCategories = (categories, flatten = false) => {
    const output = [];
    const newCategories = [
        ...categories.map((cat, index, array) => {
            return { ...array[index] };
        }),
    ];
    for (let cat of newCategories) {
        if (!cat.wpParent) {
            output.push(cat);
        }
        else {
            const parent = newCategories.findIndex((e) => e.id === cat.wpParent.node.id);
            if (!newCategories[parent].children) {
                newCategories[parent].children = [];
            }
            if (!newCategories[parent].children.find((e) => e.id === cat.id)) {
                newCategories[parent].children.push(cat);
            }
        }
    }
    if (flatten) {
        return newCategories;
    }
    return output;
};
export default fixCategories;
